// Signup.js — email/password self-signup with tier selection (scout | trader | edge).
// Mirrors Login.js (same supabase client, same form/error pattern). The chosen tier rides
// as auth user metadata (options.data.tier) — NOT a direct profiles write; the handle_new_user
// trigger reads + validates it and stamps profiles.tier on insert (user can't self-set tier).
// Rendered by the AuthGate in index.js when there is no Supabase session (toggled with Login).
import React, { useState } from "react";
import { supabase } from "./supabaseClient";

export default function Signup({ onShowLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [tier, setTier] = useState("scout");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { error: signUpError } = await supabase.auth.signUp({
      email,
      password,
      options: { data: { tier } },
    });
    if (signUpError) setError(signUpError.message);
    else setDone(true);
    setLoading(false);
    // On success with email-confirmation OFF, AuthGate's onAuthStateChange flips session and
    // renders the app (same as login). With confirmation ON, the user confirms via email first.
  };

  const inputStyle = {
    width: "100%",
    height: "44px",
    boxSizing: "border-box",
    background: "#141414",
    border: "0.5px solid #2a2a2a",
    borderRadius: "8px",
    color: "#e0e0e0",
    fontSize: "14px",
    padding: "0 12px",
    marginBottom: "12px",
    outline: "none",
    fontFamily: "inherit",
  };

  return (
    <div style={{ minHeight: "100vh", background: "#04040c", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <form
        onSubmit={handleSignup}
        style={{
          width: "100%",
          maxWidth: "360px",
          background: "rgba(22,22,22,0.82)",
          border: "0.5px solid rgba(255,255,255,0.08)",
          borderRadius: "12px",
          padding: "28px 24px",
        }}
      >
        <h1 style={{ color: "#e0e0e0", fontSize: "18px", fontWeight: 600, margin: "0 0 20px", textAlign: "center" }}>
          Create account
        </h1>
        {done ? (
          <div style={{ color: "#e0e0e0", fontSize: "14px", textAlign: "center", lineHeight: 1.5 }}>
            Account created. If email confirmation is enabled, check your inbox to confirm, then log in.
            <button
              type="button"
              onClick={onShowLogin}
              style={{ display: "block", width: "100%", marginTop: "16px", height: "44px", background: "#818cf8", border: "none", borderRadius: "8px", color: "#04040c", fontSize: "14px", fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}
            >
              Go to log in
            </button>
          </div>
        ) : (
          <>
            <input
              type="email"
              autoComplete="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={inputStyle}
              required
            />
            <input
              type="password"
              autoComplete="new-password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={inputStyle}
              required
            />
            <select
              value={tier}
              onChange={(e) => setTier(e.target.value)}
              style={inputStyle}
            >
              <option value="scout">Scout</option>
              <option value="trader">Trader</option>
              <option value="edge">Edge</option>
            </select>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                height: "44px",
                background: "#818cf8",
                border: "none",
                borderRadius: "8px",
                color: "#04040c",
                fontSize: "14px",
                fontWeight: 600,
                cursor: loading ? "default" : "pointer",
                opacity: loading ? 0.7 : 1,
                fontFamily: "inherit",
              }}
            >
              {loading ? "Creating…" : "Sign up"}
            </button>
            {error && (
              <div style={{ color: "#f97316", fontSize: "13px", marginTop: "12px", textAlign: "center" }}>
                {error}
              </div>
            )}
            <button
              type="button"
              onClick={onShowLogin}
              style={{ width: "100%", marginTop: "14px", background: "none", border: "none", color: "#818cf8", fontSize: "13px", cursor: "pointer", fontFamily: "inherit" }}
            >
              Have an account? Log in
            </button>
          </>
        )}
      </form>
    </div>
  );
}
